import {Api} from './config/request';

const getSubscriptionForParent = (parentID) => Api.getFliveRequest(`subscriptions?user_id=${parentID}`,true)

export const SubscriptionApiCalls = {
    getSubscriptionForParent,
}